import script from "./ButtonPrimaryTwitter.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonPrimaryTwitter.vue?vue&type=script&setup=true&lang=js"

import "./ButtonPrimaryTwitter.vue?vue&type=style&index=0&id=36c64f7a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aa\\Desktop\\Client-files\\BB\\BB_Web\\bb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c64f7a"]])

export default __exports__